import styled, { css } from 'styled-components'
import Icon from '../Icon'
import Link from '../Link'
import { StyledMastheadBannerProps, MastheadBannerVariant } from './MastheadBanner.types';

const primary = css`
  background-color: ${props => props.theme.colors.ERROR_RED};
`;

const secondary = css`
  background-color: ${props => props.theme.colors.BACKGROUND_NAVY};
`;

const getVariant = (variant: MastheadBannerVariant) => {
  switch (variant) {
    case 'secondary':
      return secondary
    default:
      return primary
  }
}
/*

*/
export const StyledMastheadBanner = styled.div.attrs(() => ({
  role: 'alert',
  tabIndex: -1,
}))<StyledMastheadBannerProps>`
  ${props => getVariant(props.variant)};
`

export const StyledMastheadBannerHeading = styled.h2`
  ${props => props.theme.typography.HEADING_S};
  margin-bottom: ${props => props.theme.spacing()};
`

export const StyledMastheadBannerWrapper = styled(Link)`
  display: block;
  position: relative;
  color: ${props => props.theme.colors.TEXT_WHITE};
  padding: ${props => props.theme.spacing(3, 3, 3, 0)};

  &:hover,
  &:focus {
    ${StyledMastheadBannerHeading} {
      text-decoration: underline;
    }
  }
`

export const StyledMastheadBannerMessage = styled.p`
  ${props => props.theme.typography.BODY};
`

export const StyledMastheadBannerIcon = styled(Icon).attrs(() => ({
  name: 'rightChevron',
}))`
  height: 2.9rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  ${StyledMastheadBannerWrapper}:hover &,
  ${StyledMastheadBannerWrapper}:focus & {
    transform: translate(5px, -50%);
  }
`
